export default __webpack_public_path__ + "static/media/accent_image.57d10d37.jpg";